import { Link } from "react-router-dom";
import { staff } from "../domain/data";
import { formatMailTime } from "../domain/mail";
import { useMail } from "../state/MailProvider";
import { useStudents } from "../state/students";
import { PrototypeBanner, StaffNav } from "../components/ui";

export function StaffInbox() {
  const { staffMessages } = useMail();
  const { getStudent } = useStudents();

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <StaffNav />
        <p className="meta">
          Staff · {staff.given} {staff.family} · inbox
        </p>
        <h1>Registration inbox</h1>
        <p className="lede">
          Recorded when a family submits this year's form, adds a child, or a
          student registers for an event. Each note goes to the family and to
          systems@liftteencenter.com, plus any school coordinator turned on in
          Settings. Production sends them once outbound email is turned on.
        </p>
        <div className="actions" style={{ marginTop: 0 }}>
          <Link className="btn ghost" to="/staff/settings">
            Notification settings
          </Link>
        </div>

        {staffMessages.length === 0 ? (
          <div className="wire dashed">
            <div className="meta">No registration pings yet</div>
            <p style={{ margin: "0.5rem 0 0" }}>
              Submit the year form, or register a student for an event, to see
              a message here.
            </p>
          </div>
        ) : (
          staffMessages.map((message) => {
            const student = getStudent(message.studentId);
            return (
              <div className="wire auth-mail" key={message.id}>
                <div className="meta">
                  {message.kind === "staff_rsvp"
                    ? "Event registration"
                    : message.subject.startsWith("Child added:")
                      ? "Child added"
                      : "Year form"}
                  {" · "}
                  {formatMailTime(message.createdAt, "en")}
                </div>
                <div className="row">
                  <div>
                    <strong>{message.subject}</strong>
                    <div className="anno">To {message.to.join(", ")}</div>
                    {student ? (
                      <div className="anno">
                        {student.given} {student.family} · {student.school}
                      </div>
                    ) : null}
                  </div>
                </div>
                <p className="mail-body">{message.body}</p>
              </div>
            );
          })
        )}
      </main>
    </div>
  );
}
